import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { StreamService } from '../../services/stream.service'

@Component({
    selector: 'banner-component',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
    ],
    templateUrl: 'banner.component.html',
    styleUrl: './banner.component.css'
})
export class BannerComponent implements OnInit, OnDestroy {
  activeIndex = 0
  intervalId: any

  constructor(
    private service: StreamService
  ){}

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % 3
    }, 60000)
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId)
  }
}